import RetroPhotoshootNYC from '../img/experience/4.jpg';

const RetroPhotoshootInNYC = {
	id: 4, img: RetroPhotoshootNYC, permalink: "retro-photoshoot-in-nyc", title: "Retro Photoshoot in NYC", city: "Photography - New York", location: "New York, United States", star: 4.77, cost: 35
};
export default RetroPhotoshootInNYC;